// extracted by mini-css-extract-plugin
export default {"root":"_3PE10","color-green":"_2Cr-7","colorGreen":"_2Cr-7","color-red":"i5f5_","colorRed":"i5f5_"};